import { gql, useQuery } from '@apollo/client'

export const LIST_CAMPAIGNS = gql`
  query ListCampaigns($filters: CampaignQueryFilters, $limit: Int) {
    campaignList(filters: $filters, limit: $limit) {
      campaigns {
        id
        name
        description
        tagId
        priority
        startDate
        endDate
        active
        createdAt
        updatedAt
        campaignContent {
          id
          sequence
          intervalHours
          template {
            id
            name
            channel
            description
            subjectTemplate
            bodyTemplate
          }
        }
      }
      pageInfo {
        endCursor
      }
    }
  }
`

export const GET_CAMPAIGN = gql`
  query GetCampaign($id: ID!) {
    campaign(id: $id) {
      id
      name
      description
      tagId
      priority
      startDate
      endDate
      active
      createdAt
      updatedAt
      campaignContent {
        id
        campaignId
        templateId
        sequence
        intervalHours
        template {
          id
          name
          channel
          subjectTemplate
          bodyTemplate
          description
          createdAt
          updatedAt
        }
      }
    }
  }
`

export const GET_OUTREACH_HISTORY_LIST = gql`
  query GetOutreachHistoryList(
    $filters: OutreachHistoryFilters
    $cursor: DateTimeUUIDCursor
    $limit: Int
  ) {
    outreachHistoryList(filters: $filters, cursor: $cursor, limit: $limit) {
      history {
        id
        patientId
        campaignId
        campaignContentId
        templateName
        isStepRemoved
        channel
        messageId
        sentAt
        deliveryStatus
      }
      pageInfo {
        endCursor
      }
    }
  }
`

export const GET_OUTREACH_CAMPAIGN_STATS = gql`
  query GetOutreachCampaignStats($campaignId: ID) {
    outreachCampaignStats(campaignId: $campaignId) {
      totalMessages
      uniqueAttempted
      uniqueDelivered
      sent
      failed
      undeliverable
      unsubscribed
      unknown
      lastSentAt
      byChannel {
        channel
        total
        sent
        failed
        undeliverable
        unsubscribed
        unknown
      }
      byContent {
        campaignContentId
        total
        uniqueAttempted
        uniqueDelivered
        sent
        failed
        undeliverable
        unsubscribed
        unknown
        templateName
        isRemoved
      }
    }
  }
`

export const GET_OUTREACH_DELIVERY_FORECAST = gql`
  query OutreachDeliveryForecast(
    $campaignId: ID!
    $lookbackDays: Int
    $lookaheadDays: Int
    $timezone: String
  ) {
    outreachDeliveryForecast(
      campaignId: $campaignId
      lookbackDays: $lookbackDays
      lookaheadDays: $lookaheadDays
      timezone: $timezone
    ) {
      today
      lookbackDays
      lookaheadDays
      days {
        date
        isPast
        contentSteps {
          campaignContentId
          templateName
          sequence
          isRemoved
          patientCount
        }
      }
    }
  }
`

export const useCampaignList = (options = {}) =>
  useQuery(LIST_CAMPAIGNS, {
    variables: { limit: 100 },
    fetchPolicy: 'cache-and-network',
    ...options,
  })

export const useOutreachCampaignStats = (campaignId, options = {}) =>
  useQuery(GET_OUTREACH_CAMPAIGN_STATS, {
    variables: { campaignId: campaignId ?? null },
    fetchPolicy: 'cache-and-network',
    ...options,
  })
